import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withApollo, compose } from 'react-apollo';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Button, FormGroup } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import AdminAsyncAutocomplete from '../AdminAsyncAutocomplete';
import history from '../../../core/history';
import messages from '../../../locale/messages';
import validate from './validate';
import usersQuery from './usersQuery.graphql';

import s from '../CreateReservationModal/CreateReservationModal.css';
import cp from '../../../components/commonStyle.css';

class CreateListingForm extends Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
    onStarted: PropTypes.func,
  };

  loadUserOptions = async (searchList) => {
    const { client } = this.props;
    const { data } = await client.query({
      query: usersQuery,
      variables: {
        currentPage: 1,
        searchList: searchList || '',
      },
      fetchPolicy: 'network-only',
    });

    return (data?.userManagement?.usersData || [])
      .filter((item) => item && item.id && !item.userBanStatus)
      .map((item) => {
        const name = [item.profile?.firstName, item.profile?.lastName]
          .filter(Boolean)
          .join(' ');
        return {
          value: item.id,
          label: [name, item.email].filter(Boolean).join(' — ') || item.id,
        };
      });
  };

  handleFormSubmit = (values) => {
    const { onStarted } = this.props;
    if (onStarted) {
      onStarted();
    }
    history.push(`/become-a-owner?mode=new&hostId=${encodeURIComponent(values.hostId)}`);
  };

  render() {
    const { handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.modalRoot, 'adminstyle')}>
        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          <FormGroup className={s.fieldRow}>
            <label className={cp.labelTextNew}>
              <FormattedMessage {...messages.assignListingHost} />
            </label>
            <Field
              name="hostId"
              component={AdminAsyncAutocomplete}
              loadOptions={this.loadUserOptions}
              placeholder={formatMessage(messages.searchHostPlaceholder)}
              inputClass={cp.formControlInput}
            />
          </FormGroup>

          <FormGroup className={s.fieldRow}>
            <div className={cx(cp.textAlignRight, 'textAlignLeftRTL')}>
              <Button
                type="submit"
                disabled={submitting}
                className={cx(cp.btnPrimary, cp.btnlarge)}
              >
                <FormattedMessage {...messages.createLabel} />
              </Button>
            </div>
          </FormGroup>
        </form>
      </div>
    );
  }
}

CreateListingForm = reduxForm({
  form: 'CreateListingForm',
  validate,
})(CreateListingForm);

export default compose(
  injectIntl,
  withStyles(s, cp),
  withApollo,
)(CreateListingForm);
